// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LflF","newExpiryDate":"styles_newExpiryDate__2ATJQ","footer":"styles_footer__2860O"};